/** Exact token counting via gpt-tokenizer (cl100k, the GPT-3.5/4 encoding).
 *
 *  The encoder chunk is heavy (~1MB), so it is dynamically imported once and
 *  cached. Until it arrives, callers fall back to the chars/4 estimate so a
 *  counter can render instantly. */

export type TokenCounter = (text: string) => number

/** Rough fallback used only while the real tokenizer chunk loads. */
export const estimateTokens = (text: string): number => Math.ceil(text.length / 4)

let counter: TokenCounter | null = null
let loading: Promise<TokenCounter> | null = null

export function loadTokenizer(): Promise<TokenCounter> {
  if (counter) return Promise.resolve(counter)
  if (!loading) {
    loading = import('gpt-tokenizer').then((mod) => {
      counter = (text: string) => mod.encode(text).length
      return counter
    })
  }
  return loading
}
